<template>
    <div class="navbar-unlogged__actions-cta" data-testid="navbar-signup-cta">
        <AuthLink v-slot="{navigate}" custom :role="signupRole" component-source="navbar-unlogged" :redirect="redirectUrl">
            <VJoyButton variant="main" size="small" @click="navigate">
                {{ $t(`navbar.cta.${selectedMode}.signup` as keyof AllTranslationsRecord) }}
            </VJoyButton>
        </AuthLink>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {NavbarMode} from '@navbar-unlogged-types';
    import {AuthLink} from '#components';
    import {useRequestURL} from '#imports';
    import {VJoyButton} from '@maltjoy/core-vue';
    import {useNavbarMode} from '../composables/useNavbarMode';
    import type {AllTranslationsRecord} from '#build/i18n';

    const {selectedMode} = useNavbarMode();
    const url = useRequestURL();

    const redirectUrl = computed(() => url.pathname + url.search);
    const signupRole = computed(() => (selectedMode.value === NavbarMode.FREELANCER ? 'signup-freelancer' : 'signup-client'));
</script>

<style lang="scss">
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .navbar .navbar-unlogged__actions-cta .joy-button {
        transition:
            background-color var(--navbar-scroll-transition-duration) var(--navbar-transition-easing),
            border-color var(--navbar-scroll-transition-duration) var(--navbar-transition-easing),
            color var(--navbar-scroll-transition-duration) var(--navbar-transition-easing);

        @include mq.screen_md {
            --padding-x: var(--joy-core-spacing-2);

            min-height: var(--joy-form-field-height-xsmall);
            font-size: var(--joy-font-size-primary-200);
        }
    }

    /* JOY has no light-on-image button, so the transparent bar drives the `main` one through its own tokens. */
    .navbar--transparent .navbar-unlogged__actions-cta .joy-button {
        background-color: var(--navbar-cta-surface-color);
        border-color: var(--navbar-cta-surface-color);
        color: var(--navbar-cta-text-color);

        &:hover,
        &:focus-visible {
            background-color: var(--navbar-cta-surface-hover-color);
            border-color: var(--navbar-cta-surface-hover-color);
            color: var(--navbar-cta-text-color);
        }

        &:active {
            background-color: var(--navbar-cta-surface-active-color);
            border-color: var(--navbar-cta-surface-active-color);
            color: var(--navbar-cta-text-color);
        }
    }
</style>
